export const NAME = "QuoteFlow";
export const SET_QUOTEFLOW_DATA = "SET_QUOTEFLOW_DATA";
export const SET_COMPLETE_STEPS = "SET_COMPLETE_STEPS";
export const SET_AVAILABILITY_DATES = "SET_AVAILABILITY_DATES";
export const SET_ERROR_MODAL = "SET_ERROR_MODAL";
export const SET_ADDRESS_OPTIONS = "SET_ADDRESS_OPTIONS";
export const GET_BOOKING_FLOW_SETTINGS = "GET_BOOKING_FLOW_SETTINGS";
export const POST_SALESFORCE_LEAD_DATA = "POST_SALESFORCE_LEAD_DATA";
